import React from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "../AppIcon";

const BreadcrumbStrip = () => {
  const location = useLocation();

  const breadcrumbMap = {
    "/dashboard-overview": [
      { label: "Dashboard", path: "/dashboard-overview" },
    ],
    "/daily-takings-and-tronc": [
      { label: "Dashboard", path: "/dashboard-overview" },
      { label: "Daily Takings", path: "/daily-takings-and-tronc" },
    ],
    "/tronc-distribution": [
      { label: "Dashboard", path: "/dashboard-overview" },
      { label: "Distribution", path: "/tronc-distribution" },
    ],
  };

  const currentBreadcrumbs = breadcrumbMap?.[location?.pathname] || [
    { label: "Dashboard", path: "/dashboard-overview" },
  ];

  return (
    <div className="breadcrumb-strip">
      <nav className="breadcrumb-container" aria-label="Breadcrumb">
        {currentBreadcrumbs?.map((crumb, index) => (
          <div key={crumb?.path} className="breadcrumb-item">
            {index > 0 && (
              <Icon
                name="ChevronRight"
                size={16}
                className="breadcrumb-separator"
              />
            )}
            {index === currentBreadcrumbs?.length - 1 ? (
              <span className="breadcrumb-link active" aria-current="page">
                {crumb?.label}
              </span>
            ) : (
              <Link to={crumb?.path} className="breadcrumb-link">
                {crumb?.label}
              </Link>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
};

export default BreadcrumbStrip;
